module.exports = __webpack_public_path__ + "img/puberty-decal-23.2bc7ea1e.png";